import { render, staticRenderFns } from "./TalkjsTrigButton.vue?vue&type=template&id=22f607e4&scoped=true"
import script from "./TalkjsTrigButton.vue?vue&type=script&lang=js"
export * from "./TalkjsTrigButton.vue?vue&type=script&lang=js"
import style0 from "./TalkjsTrigButton.vue?vue&type=style&index=0&id=22f607e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f607e4",
  null
  
)

export default component.exports